<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding: 15px"
>
    
    <m-auto-message-template-search-table
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    computed: {
        title() {
            if ( this.organization_label == null )
            {
                return "Automated Messages";
            }

            return "Automated Messages: "+this.organization_label;
        },
    },
}
</script>

<style lang="scss" scoped>


</style>